import { func } from "prop-types";
import React, { useState, useEffect } from "react"
import MetaTags from 'react-meta-tags';

import { Link } from "react-router-dom"
import { Container, Row, Col, Button, Input, Label, Card, CardBody } from "reactstrap"

import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import { ReactComponent as Warning } from 'assets/images/svg/warning.svg';
import { ReactComponent as Download } from 'assets/images/svg/download.svg';
import { ReactComponent as Delete } from 'assets/images/svg/delete.svg';

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"
import Pagination from "pages/Custom/Pagination";

import { checkBinId, checkDriverId, deleteBinAccount, deleteDriverAccount, getBinCompany, getBinList, getBusinessList, getDriverList, patchBusinessList, saveBinAccount, saveBinExcel, saveDriverAccount, saveDriverExcel, setNewBusinessList, updateBinList, updateDriverList } from "crud/auth.crud";

import _ from "lodash";
import moment from "moment";
import Util from "pages/Dashboard/Common/Util";

// import images
import weaver from "../../assets/images/weaver.png";
import loading from "../../assets/images/loading.gif";

import Modal from "components/RopikCustom/Modal";

const style = { backgroundColor: "#ffffff", padding: "0.5rem", cursor: "pointer", width: '466px', border: '1px solid #bdbdbd', marginTop: '0.5rem', borderRadius: '4px', color: '#333' };

const hoverStyle = { backgroundColor: "#4DBBAA", color: "#ffffff", width: '466px', border: '1px solid #4DBBAA' };

const WasteBinManagementScreen = () => {
  const history = useHistory()
  const selector = useSelector(state => state)
  const newDate = new Date()
  const nextDate = new Date()

  const [modalShow, setModalShow] = useState(false);
  const [modalShow2, setModalShow2] = useState(false);
  const [modalShow3, setModalShow3] = useState(false);
  const [modalShow4, setModalShow4] = useState(false);
  const [companyList, setCompanyList] = useState([]);
  const [dataList, setDataList] = useState(false);
  const [reset, setReset] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [isRefresh, setIsRefresh] = useState(false);
  const [isFetching, setIsFetching] = useState(false);
  const [isListEnd, setIsListEnd] = useState(false);
  const [wasteBinId, setWasteBinId] = useState('');
  const [wasteBinIdConfirm, setWasteBinIdConfirm] = useState(false);
  const [wasteBinMount, setWasteBinMount] = useState('60');
  const [targetCompany, setTargetCompany] = useState({});
  const [companyId, setCompanyId] = useState(selector.auth?.user?.member_group?.[0]?.company_group?.id);
  const [myId, setMyId] = useState(selector.auth?.user?.id);
  const [wasteBinListFile, setWasteBinListFile] = useState([]);
  const [selectedWasteBinId, setSelectedWasteBinId] = useState('');
  const [isHover, setIsHover] = useState(false)
  const [onUpload, setOnUpload] = useState(false);
  const [pagesGroup, setPagesGroup] = useState(1)
  const [pageArr, setPageArr] = useState([pagesGroup, pagesGroup + 1, pagesGroup + 2, pagesGroup + 3, pagesGroup + 4])
  const [contentCount, setContentCount] = useState()

  const mountList = [
    { 'key': '60', 'text': '60L' },
    { 'key': '120', 'text': '120L' },
    { 'key': '240', 'text': '240L' },
  ]

  const getDataList = async () => {
    setOnUpload(true)
    if (isFetching || isListEnd) {
      return;
    }

    let params = {
      page: page,
      company: companyId
    }

    setIsFetching(true)

    const response = await getBinList(params);
    const content = response.data?.results || [];
    if (!contentCount || contentCount !== Math.floor(response.data?.count / 15) + 1) {
      setContentCount(Math.floor(response.data.count / 15) + 1)
      let newArr = []
      for (let i = pagesGroup - 1; i < pagesGroup + 4; i++) {
        if (i + 1 <= Math.floor(response.data.count / 15) + 1) {
          newArr.push(i + 1)
        }
      }
      setPageArr(newArr)
    }
    if (content.length > 0) {
      setDataList([...content])
      setIsFetching(false)
    } else {
      setIsFetching(false)
      setIsListEnd(true)
    }
    setOnUpload(false)
  }

  const getCompanyList = async () => {
    setOnUpload(true)
    const rs = await getBinCompany(companyId)
    const rsData = rs.data?.data || [];
    let tmp = []
    for(let i=0; i<rsData.length; i++){            
      if(tmp.filter(itm => itm.company !== rsData[i].company)){
        tmp.push(rsData[i].contract_company_group_data)
      }            
    }
    setCompanyList(tmp)
    setOnUpload(false)
  }

  const checkPk = async () => {
    if (wasteBinId === '') {
      return alert('RFID를 입력해주세요.')
    }
    setOnUpload(true)
    const params = {
      id: wasteBinId,
    }
    const rs = await checkBinId(params)
    if (rs.data?.result === 'success') {
      setWasteBinIdConfirm(true)
    }
    alert(rs.data?.msg)
    setOnUpload(false)
  }

  const isValiddate = () => {
    if (wasteBinId === '') {
      return alert("RFID를 입력해주세요.")
    }
    if (!wasteBinIdConfirm) {
      return alert("RFID 중복확인을 해주세요.")
    }
    if (wasteBinMount === '') {
      return alert("용량을 입력해주세요.")
    }
    if (_.isEmpty(targetCompany)) {
      return alert("대상업체를 입력해주세요.")
    }
    return "success"
  }

  const saveWasteBin = async () => {
    setOnUpload(true)
    const validdate = isValiddate();
    if (validdate !== 'success') {
      setOnUpload(false)
      return;
    }
    const params = {
      'id': wasteBinId,
      'mount': wasteBinMount,
      'owner': targetCompany.id,
      'company': companyId,
      'status': 'Y',
    }
    const rs = await saveBinAccount(params)
    if (rs.status === 201) {
      setModalShow(false)
      setWasteBinId('')
      setWasteBinIdConfirm(false)
      setWasteBinMount('')
      setTargetCompany({})
      getDataList()
      alert('정상적으로 등록되었습니다.')
    } else {
      alert('등록에 실패하였습니다.')
    }
    setOnUpload(false)
  }

  const uploadWasteBinExcel = async () => {
    setOnUpload(true)
    if (wasteBinListFile == undefined || wasteBinListFile?.length == 0) { setOnUpload(false); return alert('파일을 등록하세요.') }
    try {
      const params = {
        type: 'xlsx',
        category: 'wasteBinListFile',
        company_id: companyId,
        member_id: myId
      }
      const fd = new FormData();
      fd.append('data', JSON.stringify(params));
      const newFile = new File([wasteBinListFile[0]], `${encodeURI(wasteBinListFile[0].name)}`, { type: wasteBinListFile[0].type })
      if (wasteBinListFile && !_.isEmpty(wasteBinListFile)) {
        fd.append('file_0', newFile);
      }

      const response = await saveBinExcel(fd)
      if (response.data?.result === 'success') {
        setIsRefresh(true)
        alert('정상적으로 등록되었습니다.')
      }

    } catch (e) {
      console.log(e)
    }
    setWasteBinListFile([])
    setModalShow4(false)
    setOnUpload(false)
  }

  const deleteWasteBin = async (item) => {
    if (confirm("해당 쓰레기통을 삭제하시겠습니까?")) {
      setOnUpload(true)
      {
        const params = {
          status: 'N'
        }
        const response = await deleteBinAccount(params, item.id);
        if (response?.status === 200) {
          setIsRefresh(true)
          alert('정상적으로 삭제되었습니다.')
        }
      }
      setOnUpload(false)
    }
    getDataList()
  }

  const fileDownload = async (str) => {
    let url = `https://waveradmin.ropiklabs.com/media/sample/${str}.xlsx`
    fetch(url)
      .then((response) => response.blob())
      .then((blob) => {
        const excelUrl = window.URL.createObjectURL(new Blob([blob]));
        const link = document.createElement('a');
        link.href = excelUrl;
        link.setAttribute('download', `${str}.xlsx`);
        document.body.appendChild(link);
        link.click();
      })
      .catch((error) => {
        console.error(error)
      })
  };

  const updateWasteBin = async () => {
    setOnUpload(true)
    const params = {
      'mount': wasteBinMount,
      'owner': targetCompany.id,
    }
    const response = await updateBinList(params, selectedWasteBinId);
    if (response?.status === 200) {
      setModalShow3(false)
      setSelectedWasteBinId('')
      setWasteBinId('')
      setWasteBinIdConfirm(false)
      setWasteBinMount('')
      setTargetCompany({})
      alert('정상적으로 수정되었습니다.')
    }else {
      alert('수정에 실패하였습니다.')
    }
    setOnUpload(false)
  }

  const openUpdateModal = (item) => {
    setModalShow3(true)
    setWasteBinId(item.id)
    setWasteBinMount(item.mount + '')
    setTargetCompany(item.owner_company_data)
    setSelectedWasteBinId(item.id)
  }

  const registFiles = (e) => {
    setWasteBinListFile([...e.target.files])
  }

  const deleteFile = (item) => {
    setWasteBinListFile(wasteBinListFile.filter(data => data !== item))
  }

  const modalClose = () => {
    setModalShow2(false)
  }

  useEffect(() => {
    getDataList()
    getCompanyList()
  }, [isRefresh, modalShow, modalShow3, modalShow4, page])

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>쓰레기통 관리 | 웨이스트버스</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs maintitle="Home" title="마이웨버" breadcrumbItem="쓰레기통 관리" />

          {!modalShow && !modalShow2 && !modalShow3 && !modalShow4 &&
            <Row>
              <Col xs={12} className="waver-pagination-btn-group mb-4 text-end" style={{maxWidth: '25.625rem'}}>
                {/* <button className="waves-effect submit-btn btn btn-secondary zfont-size-16"
                  onClick={() => { setModalShow4(true) }}>일괄등록</button> */}
                <button className="waves-effect submit-btn btn btn-secondary zfont-size-16 margin-left-16" onClick={() => { setModalShow(true) }}
                >개별등록</button>
              </Col>
            </Row>
          }

          <Row>
            <Col xs={12} style={{maxWidth: '25.625rem'}}>
              <div className="email-rightbar mb-3">
                <Card className="overflow-hidden">

                  {!modalShow && !modalShow2 && !modalShow3 && !modalShow4 &&
                    <div className="radius-4 overflow-hidden">
                      <div className="table-responsive">
                        <table className="table table-hover table-centered table-nowrap mb-0 chart-table">
                          <thead className="chart-thead">
                            <tr>
                              <th scope="col" >RFID</th>
                              <th scope="col" >대상업체</th>
                              <th scope="col" >용량(L)</th>
                              <th scope="col" >삭제</th>
                            </tr>
                          </thead>
                          <tbody className="chart-tbody">
                            {dataList && dataList.map((item, index) => {
                              return (
                                <tr className="pointer" key={item.id + '_' + index} onClick={() => { openUpdateModal(item) }}>
                                  <td>{item.id}</td>
                                  <td>{item.owner_company_data?.name}</td>
                                  <td>{item.mount}</td>
                                  <td><i className="mdi mdi-trash-can-outline font-size-18 pointer" onClick={() => {
                                    deleteWasteBin(item)
                                  }} /></td>
                                </tr>
                              )
                            })
                            }
                            {!dataList &&
                              <tr>
                                <td scope="row" colSpan="6">데이터가 없습니다.</td>
                              </tr>
                            }
                          </tbody>
                        </table>
                      </div>
                    </div>
                  }

                  {modalShow &&
                    <CardBody className="p-4">

                      <div className="d-flex mb-4">
                        <div style={{ flexGrow: 1 }}>
                          <p className="noMargin text-black font-weight-bold font-size-16">쓰레기통 RFID</p>
                          <input type="text" placeholder="RFID를 입력해주세요" className="is-touched is-dirty av-valid form-control mt-2 font-size-16" onChange={(e) => {
                            setWasteBinId(e.target.value)
                            setWasteBinIdConfirm(false)
                          }} />
                        </div>
                        <div className="waver-pagination-btn-group" >
                          <button className="waves-effect submit-btn btn btn-secondary margin-top-35 margin-left-6 font-size-16"
                            onClick={() => {
                              checkPk()
                            }}
                          >중복확인</button>
                        </div>
                      </div>

                      <div className="d-flex mb-4">
                        <div style={{ flexGrow: 1 }}>
                          <p className="noMargin text-black font-weight-bold font-size-16">대상업체</p>
                          <input type="text" placeholder="대상업체를 선택해주세요" className="is-touched is-dirty av-valid form-control mt-2 font-size-16" value={targetCompany.name} disabled
                            onChange={(e) => {
                              setWasteBinId(e.target.value)
                              setWasteBinIdConfirm(false)
                            }} />
                        </div>
                        <div className="waver-pagination-btn-group" >
                          <button className="waves-effect submit-btn btn btn-secondary margin-top-35 margin-left-6 font-size-16"
                            onClick={() => {
                              setModalShow2(true)
                            }}
                          >업체선택</button>
                        </div>
                      </div>

                      <div className="mb-4">
                        <p className="noMargin text-black font-weight-bold font-size-16">용량</p>
                        {mountList && mountList.map((item, index) => {
                          return (
                            <div className="form-check form-check-inline mt-2" key={item.key + '_' + index}>
                              <input className="is-untouched is-pristine av-valid form-check-input" checked={wasteBinMount == item.key} type='radio' id={item.key} name="employees" value={item.key} onClick={(e) => { setWasteBinMount(item.key) }} />
                              <label className="noMargin form-check-label font-size-16 text-black" htmlFor={item.key} >{item.text}</label>
                            </div>
                          )
                        })
                        }
                      </div>

                      <div className="d-flex mt-4 justify-content-end">
                        <button className="waves-effect btn btn-silver font-size-16" onClick={() => {
                          setModalShow(false)
                        }}>취소</button>
                        <button className="waves-effect btn btn-primary font-size-16" onClick={() => {
                          saveWasteBin()
                        }}>등록하기</button>
                      </div>

                      <Modal title={'대상업체 선택'} show={modalShow2} onHide={modalClose} size="md" >
                        <div style={{ maxHeight: 300, overflow: "hidden auto" }}>
                          {modalShow2 && companyList.map((item) => {
                            return (
                              <div style={isHover == item.id ? { ...style, ...hoverStyle } : { ...style }} key={item.id}
                                onMouseOver={() => {
                                  setIsHover(item.id)
                                }}
                                onMouseLeave={() => {
                                  setIsHover(false)
                                }}
                                onClick={() => {
                                  setTargetCompany(item)
                                  setModalShow2(false)
                                }}>{item.name}
                              </div>
                            )
                          })}
                        </div>
                      </Modal>

                    </CardBody>
                  }

                  {modalShow3 &&
                    <CardBody className="p-4">

                      <div className="d-flex mb-4">
                        <div style={{ flexGrow: 1 }}>
                          <p className="noMargin text-black font-weight-bold font-size-16">쓰레기통 RFID</p>
                          <input type="text" className="is-touched is-dirty av-valid form-control mt-2 font-size-16" defaultValue={wasteBinId} disabled />
                        </div>
                      </div>

                      <div className="d-flex mb-4">
                        <div style={{ flexGrow: 1 }}>
                          <p className="noMargin text-black font-weight-bold font-size-16">대상업체</p>
                          <input type="text" className="is-touched is-dirty av-valid form-control mt-2 font-size-16" value={targetCompany.name} disabled
                            onChange={(e) => {
                              setWasteBinId(e.target.value)
                              setWasteBinIdConfirm(false)
                            }} />
                        </div>
                        <div className="waver-pagination-btn-group" >
                          <button className="waves-effect submit-btn btn btn-secondary margin-top-35 margin-left-6 font-size-16"
                            onClick={() => {
                              setModalShow2(true)
                            }}
                          >업체선택</button>
                        </div>
                      </div>

                      <div className="mb-4">
                        <p className="noMargin text-black font-weight-bold font-size-16">용량</p>
                        {mountList && mountList.map((item, index) => {
                          return (
                            <div className="form-check form-check-inline mt-2" key={item.key + '_' + index}>
                              <input className="is-untouched is-pristine av-valid form-check-input" checked={wasteBinMount == item.key} type='radio' id={item.key} name="employees" value={item.key} onClick={(e) => { setWasteBinMount(item.key) }} />
                              <label className="noMargin form-check-label font-size-16 text-black" htmlFor={item.key} >{item.text}</label>
                            </div>
                          )
                        })
                        }
                      </div>

                      <div className="d-flex mt-4 justify-content-end">
                        <button className="waves-effect btn btn-silver font-size-16" onClick={() => {
                          setModalShow3(false)
                        }}>취소</button>
                        <button className="waves-effect btn btn-primary font-size-16" onClick={() => {
                          updateWasteBin()
                        }}>수정하기</button>
                      </div>

                      <Modal title={'대상업체 선택'} show={modalShow2} onHide={modalClose} size="md" >
                        <div style={{ maxHeight: 300, overflow: "hidden auto" }}>
                          {modalShow2 && companyList.map((item) => {
                            return (
                              <div style={isHover == item.id ? { ...style, ...hoverStyle } : { ...style }} key={item.id}
                                onMouseOver={() => {
                                  setIsHover(item.id)
                                }}
                                onMouseLeave={() => {
                                  setIsHover(false)
                                }}
                                onClick={() => {
                                  setTargetCompany(item)
                                  setModalShow2(false)
                                }}>{item.name}
                              </div>
                            )
                          })}
                        </div>
                      </Modal>

                    </CardBody>
                  }

                  {modalShow4 &&
                    <CardBody className="p-4">

                      <div className="download-container mt-2 d-flex flex-column justify-content-between" style={{ height: 'fit-content' }}>
                        <div className="d-flex align-items-top">
                          <Warning width={28} height={22} />
                          <p className="noMargin font-size-14 text-black padding-left-8">파일 업로드시, 기존 목록과 파일의 중복된 내용을 제외한 나머지 부분만 등록됩니다.  삭제는 개별 삭제 해주세요.</p>
                        </div>
                        <div className="waver-pagination-btn-group float-right d-flex justify-content-end">
                          <button className="waves-effect submit-btn btn btn-secondary font-size-14 mt-2"
                            onClick={() => {
                              fileDownload('쓰레기통등록엑셀')
                            }}
                          >샘플 엑셀파일 다운로드<Download className="margin-left-8" />
                          </button>
                        </div>
                      </div>

                      <label style={{ padding: '0.4rem 1rem', borderRadius: '0.2rem', margin: "18px 0", fontSize: 16 }} htmlFor="ex_file" className="btn btn-primary dropdown-toggle waves-effect waves-light">파일선택
                      </label>
                      <input style={{ display: "none" }} type="file" accept=".xls,.xlsx" id="ex_file" onChange={(e) => {
                        registFiles(e)
                      }} />

                      {wasteBinListFile.length > 0 && wasteBinListFile.map((item, index) => {
                        return (
                          <div className="file-confirm" key={index}>
                            <p className="noMargin">{item.name}</p>
                            <Delete className="margin-left-8 pointer" onClick={() => { deleteFile(item) }} />
                          </div>
                        )
                      })}

                      <div className="d-flex mt-4 justify-content-end">
                        <button className="waves-effect btn btn-silver font-size-16" onClick={() => {
                          setModalShow4(false)
                        }}>취소</button>
                        <button className="waves-effect btn btn-primary font-size-16" onClick={async () => {
                          await uploadWasteBinExcel()
                        }}>등록하기</button>
                      </div>

                    </CardBody>
                  }

                  {onUpload && <div style={{
                    position: "absolute",
                    width: '100%',
                    height: '100%',
                    top: 0,
                    left: 0,
                    background: 'rgba(255, 255, 255, 0.6)',
                    zIndex: 999,
                    display: "flex",
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}>
                    <img src={loading} alt="로딩중입니다." width={'5%'}></img>
                  </div>}

                </Card>

                {!modalShow && !modalShow2 && !modalShow3 && !modalShow4 &&
                  <Pagination contentCount={contentCount} pageArr={pageArr} pageCallBack={(page)=>{setPage(page)}} />
                }

              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default WasteBinManagementScreen